import React from 'react';
import Routes from './Routes';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import ToastNotifications from './components/ui/ToastNotifications';

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <Routes />
        <ToastNotifications />
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
